var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPanama(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0127C24.8366 32.0127 32 24.8493 32 16.0127C32 7.17614 24.8366 0.0126953 16 0.0126953C7.16344 0.0126953 0 7.17614 0 16.0127C0 24.8493 7.16344 32.0127 16 32.0127Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0127C0 24.8492 7.1635 32.0127 16 32.0127C16 25.928 16 16.0127 16 16.0127C16 16.0127 5.56519 16.0127 0 16.0127Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0.0126953C24.8365 0.0126953 32 7.1762 32 16.0127C25.9153 16.0127 16 16.0127 16 16.0127C16 16.0127 16 5.57788 16 0.0126953Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.52352 5.57791L10.5596 8.76654H13.9123L11.1999 10.7372L12.2359 13.9258L9.52352 11.9551L6.81114 13.9258L7.84714 10.7372L5.13477 8.76654H8.48745L9.52352 5.57791Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4762 18.0995L23.5122 21.2881H26.8649L24.1525 23.2588L25.1885 26.4474L22.4762 24.4767L19.7638 26.4474L20.7998 23.2588L18.0874 21.2881H21.4401L22.4762 18.0995Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53429"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0126953)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanama);
export default __webpack_public_path__ + "static/media/panama.2f3a8a04.svg";
export { ForwardRef as ReactComponent };